import React from "react";

import { initialize } from "../actions";

const withInitialization = store => Component => {
  class WithInitialization extends React.Component {
    constructor(props) {
      super(props);

      store.dispatch(initialize(props));
    }

    render() {
      return <Component {...this.props} />;
    }
  }

  return WithInitialization;
};

export default withInitialization;
